import { Color } from 'modules/styles/colors';
import { FontWeight } from 'modules/styles/variables';

export default {
  RULES: [
    {
      age: 'Newborn-2 months',
      description: 'Please Call Clinic',
      fontWeight: FontWeight.bold,
      bgColor: Color.grayLight3
    },
    {
      age: '2 months',
      description: 'Not before 6 weeks',
      fontWeight: '',
      bgColor: ''
    },
    {
      age: '4 months',
      description: 'At least 6 weeks after 2-month Well Child Check',
      fontWeight: FontWeight.bold,
      bgColor: Color.grayLight3
    },
    {
      age: '6 months',
      description: 'At least 2 days after they turn 6 months old',
      fontWeight: '',
      bgColor: ''
    },
    {
      age: '9 months',
      description: 'At least 2 days after they turn 9 months old',
      fontWeight: '',
      bgColor: Color.grayLight3
    },
    {
      age: '12 months',
      description: 'At least 2 days after they turn 12 months old',
      fontWeight: '',
      bgColor: ''
    },
    {
      age: '14-15 months',
      description: 'At least 15 months old',
      fontWeight: '',
      bgColor: Color.grayLight3
    },
    {
      age: '18 months',
      description: 'At least 6 months after 12-month Well Child Check',
      fontWeight: FontWeight.bold,
      bgColor: ''
    },
    {
      age: '24 months',
      description: 'At least 2 days after they turn 24 months old',
      fontWeight: '',
      bgColor: Color.grayLight3
    },
    {
      age: '3-10 years',
      description:
        'No sooner than 366 days from last WCC \n4 Year – No sooner than 2 days after their 4-year birthday \n9 Year – No sooner than 2 days after their 9-year birthday',
      fontWeight: FontWeight.bold,
      bgColor: ''
    }
  ]
};
